import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './DataParametersPanel.module.css';
import SimpleLoader from '../../loaders/SimpleLoader';
import { generatePreviewForProperty } from '../../../utils/blazeDataUtils';
import { showToastNotification } from '../../../store/ui/toasts/toastsActions';
import { ToastType } from '../../../store/ui/toasts/toastsTypes';
import { getErrorMessage } from '../../../utils/miscUtil';
import { useDispatch } from 'react-redux';
import BzmIcon from '../../icons/BzmIcon';

type DataPreviewProps = {
  id: string;
  text: string;
  entityName: string;
  propertyName: string;
  dataModel?: any;
};

const DataPreview = (props: DataPreviewProps) => {
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [value, setValue] = useState<string | undefined>(props.text);
  const [isShowingPreview, setIsShowingPreview] = useState(false);
  const { dataModel, propertyName, entityName } = props;
  const dispatch = useDispatch();

  const togglePreview = async (event: any) => {
    //Don`t bubble up
    event.stopPropagation();
    if (!isShowingPreview) {
      setIsLoadingPreview(true);
      try {
        const generatedValue = await generatePreviewForProperty(dataModel, entityName, propertyName);
        setValue(generatedValue);
      } catch (e) {
        dispatch(showToastNotification(ToastType.Danger, 'Cannot get parameter preview', getErrorMessage(e)));
      } finally {
        setIsLoadingPreview(false);
      }
    } else {
      // Use original value
      setValue(props.text);
    }
    setIsShowingPreview(!isShowingPreview);
  };

  const eyeIcon = isShowingPreview ? 'icon-bzm-eye-off' : 'icon-bzm-eye text-primary';

  return (
    <div className={styles.preview}>
      <span className={clsx('align-middle hand-cursor', styles.link)} title={props.text}>
        {isLoadingPreview && (
          <SimpleLoader
            className={'d-inline-block align-middle'}
            loaderSize={16}
            loadingText={'Loading Parameter Value...'}
          />
        )}
        {!isLoadingPreview && <>{value}</>}
      </span>
      {!isLoadingPreview && (
        <BzmIcon
          onClick={(event: any) => togglePreview(event)}
          variant={eyeIcon}
          className={clsx(
            'icon-xs ml-2 align-middle hand-cursor icon',
            isShowingPreview ? styles.iconForcedVisibility : styles.icon,
          )}
        ></BzmIcon>
      )}
    </div>
  );
};

export default DataPreview;
